import React, { useState } from "react";
import useFetch from "../../../../hooks/useAxios";
import NotificationCard from "./NotificationCard";
import NotificationFilter from "./NotificationFilter";

const AdminNotification = () => {
  const [tabid, settabid] = useState("comment"); //comment //reserve //residence //payment //withdraw//report
  const [notList, setnotList] = useState([]);
  const apinotList = useFetch({
    method: "get",
    url: "api/admin/notifications",
    noHeader: false,
    trigger: true,
    argFunc: res => setnotList(res.data)
  });
  return (
    <div className="AdminNotification ">
      <div className="flex justify-between items-center AdminNotification--header">
        <h3>اعلانات وبسایت</h3>
        {/* <div className='flex gap-[36px] items-center'>
          <button>همه اعلانات</button>
          <button>پاسخ داده شده</button>
          <button>خوانده شده</button>
          <button>خوانده نشده</button>
        </div> */}
      </div>
      <NotificationFilter tabid={tabid} settabid={settabid} />
      <div className="AdminNotification--grid">
        {tabid === "comment"
          ? notList.comment?.map(i => <NotificationCard info={i}/>)
          : tabid === "reserve"
            ? notList.reserve?.map(i => <NotificationCard info={i}/>)
          : tabid === "residence"
              ? notList.residence?.map(i => <NotificationCard info={i}/>)
          : tabid === "payment"
                ? notList.payment?.map(i => <NotificationCard info={i}/>)
          : tabid === "withdraw"
                  ? notList.withdraw?.map(i => <NotificationCard info={i}/>)
          : tabid === "report"
                    ? notList.report?.map(i => <NotificationCard info={i}/>)
          : null}
      </div>
    </div>
  );
};

export default AdminNotification;
